if (!customElements.get('ulviva-technical')) {
  customElements.define('ulviva-technical', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
      this.controller = new AbortController();
      try { this.profile = JSON.parse(this.querySelector('[data-profile]').textContent); } catch { return; }
      this.form = this.querySelector('[data-uv-dose-form]');
      this.rules = this.querySelector('[data-uv-dose-rule]');
      this.water = this.querySelector('[data-uv-water]');
      this.output = this.querySelector('[data-uv-dose-result]');
      this.form?.addEventListener('submit', event => { event.preventDefault(); this.calculate(); }, {signal:this.controller.signal});
      this.form?.addEventListener('input', () => this.resetResult(), {signal:this.controller.signal});
      this.rules?.addEventListener('change', () => this.showRule(), {signal:this.controller.signal});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          const owner = data.html?.querySelector('product-info');
          if (String(owner?.dataset.productId) !== this.dataset.productId) return;
          const format = data.html?.querySelector('ulviva-product-gallery')?.dataset.format;
          if (format) this.setFormat(format);
          const contact = data.html?.querySelector('[data-uv-whatsapp][data-kind="product"][data-source="product"]');
          if (contact?.href) this.querySelectorAll('[data-uv-whatsapp][data-kind="product"]').forEach(link => { link.href = contact.href; });
        });
      }
      this.setFormat(this.dataset.format);
      if (this.form && this.rules && this.water && this.output) this.form.hidden = false;
    }
    setFormat(format) {
      this.dataset.format = String(format);
      this.querySelectorAll('[data-formats]').forEach(el => {
        const applies = el.dataset.formats.split(',').includes(String(format));
        el.hidden = !applies;
        if (el.tagName === 'OPTION') el.disabled = !applies;
      });
      this.querySelectorAll('[data-uv-current-format]').forEach(el => el.textContent = `${format} L`);
      const table = this.querySelector('[data-uv-technical-table]');
      if (table) table.hidden = ![...table.querySelectorAll('tbody tr')].some(row => !row.hidden);
      if (this.rules) this.rules.value = '';
      this.showRule();
    }
    selectedRule() {
      return this.profile.applications.find(r => r.id === this.rules?.value && r.public === true && r.calculatorEligible === true && r.status === 'verified_supplier_label' && r.dose.unit === 'mL/L' && r.formatLitres.includes(Number(this.dataset.format)));
    }
    resetResult() {
      if (this.output) { this.output.textContent = this.output.dataset.empty; delete this.output.dataset.totalMl; }
    }
    showRule() {
      this.resetResult();
      const rule = this.selectedRule();
      const context = this.querySelector('[data-uv-dose-context]');
      if (context) context.textContent = rule ? `${rule.stage} · ${rule.schedule}. ${rule.dose.sourceExpression}.` : '';
      const link = this.querySelector('[data-uv-dose-source]');
      if (link) {
        const sourceId = rule?.sourceIds?.[0];
        const source = sourceId ? this.querySelector(`[data-source-id="${CSS.escape(sourceId)}"]`) : null;
        link.hidden = !source?.href;
        if (source?.href) link.href = source.href;
      }
    }
    calculate() {
      const rule = this.selectedRule();
      const water = Number(this.water?.value);
      const min = Number(rule?.dose?.min), max = Number(rule?.dose?.max);
      if (!rule || !this.water.validity.valid || !Number.isFinite(water) || water <= 0 || !Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max < min) {
        this.output.textContent = this.output.dataset.invalid;
        delete this.output.dataset.totalMl;
        return;
      }
      const totals = [min * water, max * water];
      if (!totals.every(Number.isFinite)) { this.output.textContent = this.output.dataset.invalid; return; }
      const format = new Intl.NumberFormat(document.documentElement.lang || 'es', {maximumFractionDigits:6});
      const unit = totals[0] >= 1000 ? 'L' : 'mL';
      const divisor = unit === 'L' ? 1000 : 1;
      const amount = format.format(totals[0] / divisor) + (max !== min ? `–${format.format(totals[1] / divisor)}` : '');
      this.output.textContent = `${this.output.dataset.resultLabel}: ${amount} ${unit}. ${format.format(water)} L ${this.output.dataset.waterLabel}. ${this.output.dataset.concentrationLabel}: ${format.format(min)}${max !== min ? `–${format.format(max)}` : ''} mL/L.`;
      this.output.dataset.totalMl = JSON.stringify(totals);
    }
    disconnectedCallback() { this.controller?.abort(); this.unsubscribe?.(); }
  });
}
